// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartButton_button__0lXN-","icon":"HeaderCartButton_icon__Ispuv","badge":"HeaderCartButton_badge__-TYO+","bump":"HeaderCartButton_bump__uMXjk"};